// extracted by mini-css-extract-plugin
export default {"saveButton":"createPromotionForm_saveButton__pL3uq","select":"createPromotionForm_select__SILMp"};